import { __generator, __values } from "tslib";
import { put, call, select, takeEvery } from 'redux-saga/effects';
import { partial } from 'lodash-es';
import { Canvas } from '@marvelapp/easel-client';
import * as actionTypes from '../constants/actionTypes';
import * as actionCreators from '../actionCreators';
import { getProjectNumericID, getCurrentScreen, getEaselConfig, getCurrentCanvasID, isInHandoffMode as getIsInHandoffMode, } from '../selectors';
import configureEasel from '../utils/handoff/configureEasel';
/*
  SHOW_SCREEN - switching between screens in handoff mode
  SHOW_HANDOFF - entering handoff (needed in case a layer is shown
    and we need to load its canvas data)
  LOAD_HOTSPOTS_DONE - initial load (We need to listen to this
    to make sure hotspotMap is available (hotspots load after project loads),
    in case we open handoff before hotspots fully loaded)
*/
var screenChangeActions = [
    actionTypes.SHOW_SCREEN,
    actionTypes.SHOW_HANDOFF,
    actionTypes.LOAD_HOTSPOTS_DONE,
];
export default function loadCanvas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(screenChangeActions, function () {
                    var isInHandoffMode, easelConfig, projectID, currentScreen, canvasClient_1, easelResponse, err_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, select(getIsInHandoffMode)];
                            case 1:
                                isInHandoffMode = _a.sent();
                                if (!isInHandoffMode) {
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, select(getEaselConfig)];
                            case 2:
                                easelConfig = _a.sent();
                                configureEasel(easelConfig);
                                return [4 /*yield*/, select(getProjectNumericID)];
                            case 3:
                                projectID = _a.sent();
                                return [4 /*yield*/, select(getCurrentScreen)];
                            case 4:
                                currentScreen = _a.sent();
                                if (!currentScreen.canvasID) {
                                    return [2 /*return*/];
                                }
                                return [5 /*yield**/, __values(isCanvasAlreadyLoaded(currentScreen))];
                            case 5:
                                if (_a.sent()) {
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, put(actionCreators.loadCanvasStarting())];
                            case 6:
                                _a.sent();
                                _a.label = 7;
                            case 7:
                                _a.trys.push([7, 11, , 13]);
                                return [4 /*yield*/, call(partial(Canvas.load, projectID, currentScreen.canvasID))];
                            case 8:
                                canvasClient_1 = _a.sent();
                                return [4 /*yield*/, call(function () { return canvasClient_1.fetch(); })];
                            case 9:
                                easelResponse = _a.sent();
                                return [4 /*yield*/, put(actionCreators.loadCanvasDone(easelResponse.canvas, currentScreen.sourcePlatform))];
                            case 10:
                                _a.sent();
                                return [3 /*break*/, 13];
                            case 11:
                                err_1 = _a.sent();
                                return [4 /*yield*/, put(actionCreators.loadCanvasFailed(currentScreen.id, err_1))];
                            case 12:
                                _a.sent();
                                return [3 /*break*/, 13];
                            case 13: return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function isCanvasAlreadyLoaded(currentScreen) {
    var currentCanvasID;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getCurrentCanvasID)];
            case 1:
                currentCanvasID = _a.sent();
                return [2 /*return*/, currentCanvasID === currentScreen.canvasID];
        }
    });
}
